import { AKUA_ENABLED } from "../config";
import facturacion from "./facturacion";
import pedidos from "./pedidos";
import terminales from "./terminales";

// ==============================|| MENU ITEMS ||============================== //

const baseItems = [pedidos];
const akuaItems = [terminales, facturacion];

const menuItemsVendedor = {
  items: AKUA_ENABLED ? [...baseItems, ...akuaItems] : baseItems,
};
const menuItems = menuItemsVendedor;

export default menuItems;
